import React, { Component } from 'react';
import { safeParse } from '../utils';
import {
  ChevronIcon2
} from './SVGIcons';
import Social from './Social'
import OffcanvasForm from './OffcanvasForm';
import Breadcrumbs from './Breadcrumbs';

// Обёртка над html-react-parser: не падает на пустом/undefined значении
// (раньше SSR бросал TypeError и вся страница отдавала 503 «Технические работы»)
const Parser = safeParse;

class App extends Component {
  state = {
    showKPForm: false,
    showPriceForm: false,
    lightboxOpen: false,  // Добавляем состояние для lightbox
    activeFasovka: 0,      // Индекс активной фасовки
    zoomLevel: 2           // Уровень зума: 2x по умолчанию
  };

  // Для drag-to-pan
  isDragging = false;
  dragStartX = 0;
  dragStartY = 0;
  dragOffsetX = 0;
  dragOffsetY = 0;

  // Методы для открытия форм
  openKPForm = () => {
    this.setState({ showKPForm: true });
  };

  openPriceForm = () => {
    this.setState({ showPriceForm: true });
  };

  // Методы для закрытия форм
  closeKPForm = () => {
    this.setState({ showKPForm: false });
  };

  closePriceForm = () => {
    this.setState({ showPriceForm: false });
  };

  // Обработчик успешной отправки
  handleFormSuccess = (message) => {
    if (this.props.onSuccess) {
      this.props.onSuccess(message);
    }
  };

  // Обработчик ошибки отправки
  handleFormError = (error) => {
    if (this.props.onError) {
      this.props.onError(error);
    }
  };

  // Методы для lightbox
  openLightbox = () => {
    this.setState({ lightboxOpen: true });
    document.body.style.overflow = 'hidden';
  };

  closeLightbox = () => {
    this.setState({ lightboxOpen: false });
    document.body.style.overflow = 'auto';
  };

  // Обработка нажатия клавиш
  handleKeyDown = (e) => {
    if (!this.state.lightboxOpen) return;
    
    if (e.key === 'Escape') {
      this.closeLightbox();
    }
  };

  componentDidMount() {
    window.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
    document.body.style.overflow = 'auto';
  }

  render() {
    const data = this.props?.data || {}
    const product = data?.product || {}
    const { showKPForm, showPriceForm, lightboxOpen, activeFasovka } = this.state
    const market = data?.market || []

    // Определяем, есть ли фасовка
    const hasFasovka = Array.isArray(product?.fasovka) && product.fasovka.length > 0
    // Текущее изображение: если есть фасовка — берем из выбранного элемента, иначе из product.image
    const currentImage = hasFasovka ? product.fasovka[activeFasovka]?.image : product?.image
    // Название товара для форм: если выбрана фасовка — добавляем её название к основному
    const formProductName = hasFasovka ? (data?.pagetitle + ' - ' + product.fasovka[activeFasovka]?.name) : data?.pagetitle

    return (
      <>
        <div className='mt-[95px] xl:mt-[150px] leading-none'>
          <div className='container'>
            <Breadcrumbs breadcrumbs={data?.breadcrumbs} />
            <h1 className='font-medium mt-[30px] xl:mt-[40px] tracking-[-0.04em] text-[#032432] text-[24px] xl:text-[36px] text-center xl:text-start'>
              {Parser(data?.pagetitle)}
            </h1>
            <h2 className='mt-[15px] text-[14px] xl:text-[16px] tracking-[-0.02em] text-[#032432]/60 text-center xl:text-start'>Характеристики</h2>
            <div className={`mt-[10px] flex flex-col xl:flex-row justify-between gap-[10px]`}>
              <div className={`bg-[#F5F7F9] p-[10px] rounded-[15px] flex flex-col xl:flex-row items-end gap-[20px]` + (product?.opasnost + product?.transport == '' ? ` w-full` : '')}>
                {currentImage != '' && currentImage != null &&
                  <img
                    src={currentImage}
                    alt={data?.pagetitle}
                    width={242}
                    height={242}
                    className='h-auto bg-white flex-none rounded-[15px] w-[335px] xl:w-[242px] max-w-full cursor-pointer transition-transform hover:scale-105 duration-300'
                    onClick={this.openLightbox}
                  />
                }
                
                {/* Блок фасовки (справа от фото) */}
                {hasFasovka && (
                  <div className='flex flex-col gap-[10px] max-w-[600px]'>
                    <h3 className='text-[16px] xl:text-[18px] text-[#032432] font-medium'>Фасовка</h3>
                    <div className='flex flex-wrap gap-[8px]'>
                      {product.fasovka.map((elm, index) => (
                        <div
                          key={index}
                          onClick={() => this.setState({ activeFasovka: index })}
                          className={`px-[31px] py-[15px] rounded-full cursor-pointer text-[16px] xl:text-[18px] transition-colors duration-200 ${
                            activeFasovka === index
                              ? 'bg-[#032432] text-white'
                              : 'bg-white text-[#032432]'
                          }`}
                        >
                          {elm.name}
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Используем flex с переносом вместо grid */}
                <div className={`flex flex-1 items-center flex-wrap gap-[8px]` + (product?.opasnost + product?.transport == '' ? ` justify-between` : '')}>
                  {(product?.shortinfo || []).map((elm, index) => (
                    <div key={index} className="flex-1 min-w-[150px]">
                      <div className='mb-[5px] text-[16px] xl:text-[18px] text-[#032432]'>{elm?.name}</div>
                      <div className='mb-[5px] text-[14px] xl:text-[16px] text-[#032432]/60 break-words break-all'>{elm?.text}</div>
                    </div>
                  ))}
                </div>
              </div>
              {product?.opasnost + product?.transport != `` &&
                <div className='flex-none'>
                  {product?.opasnost != `` &&
                    <div className='w-full xl:w-[574px] bg-[#032432] rounded-[15px] p-[20px] mb-[10px]'>
                      <div className='flex items-center gap-[9px] text-[16px] xl:text-[18px] text-white'>
                        <svg className='flex-none' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12 9V14" stroke="#D7000B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M11.9994 21.4103H5.93944C2.46944 21.4103 1.01944 18.9303 2.69944 15.9003L5.81944 10.2803L8.75944 5.00027C10.5394 1.79027 13.4594 1.79027 15.2394 5.00027L18.1794 10.2903L21.2994 15.9103C22.9794 18.9403 21.5194 21.4203 18.0594 21.4203H11.9994V21.4103Z" stroke="#D7000B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M11.9941 17H12.0031" stroke="#D7000B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <h3>Опасность</h3>
                      </div>
                      <div className='text-[14px] xl:text-[16px] text-white/60 mt-[10px]'>{Parser(product?.opasnost)}</div>
                    </div>
                  }
                  {product?.transport != `` &&
                    <div className='w-full xl:w-[574px] bg-[#009EE3] rounded-[15px] p-[20px]'>
                      <div className='flex items-center gap-[9px] text-[16px] xl:text-[18px] text-white'>
                        <svg className='flex-none' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M11.9998 14H12.9998C14.0998 14 14.9998 13.1 14.9998 12V2H5.99976C4.49976 2 3.18977 2.82999 2.50977 4.04999" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M2 17C2 18.66 3.34 20 5 20H6C6 18.9 6.9 18 8 18C9.1 18 10 18.9 10 20H14C14 18.9 14.9 18 16 18C17.1 18 18 18.9 18 20H19C20.66 20 22 18.66 22 17V14H19C18.45 14 18 13.55 18 13V10C18 9.45 18.45 9 19 9H20.29L18.58 6.01001C18.22 5.39001 17.56 5 16.84 5H15V12C15 13.1 14.1 14 13 14H12" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M8 22C9.10457 22 10 21.1046 10 20C10 18.8954 9.10457 18 8 18C6.89543 18 6 18.8954 6 20C6 21.1046 6.89543 22 8 22Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 22C17.1046 22 18 21.1046 18 20C18 18.8954 17.1046 18 16 18C14.8954 18 14 18.8954 14 20C14 21.1046 14.8954 22 16 22Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M22 12V14H19C18.45 14 18 13.55 18 13V10C18 9.45 18.45 9 19 9H20.29L22 12Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M2 8H8" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M2 11H6" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M2 14H4" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <h3>Транспортировка</h3>
                      </div>
                      <div className='text-[14px] xl:text-[16px] text-white/60 mt-[10px]'>{Parser(product?.transport)}</div>
                    </div>
                  }
                </div>
              }
            </div>
            <div className='flex flex-col xl:flex-row items-center justify-start gap-[10px] mt-[12px]'>
              {/* Кнопка Получить коммерческое предложение */}
              <div 
                onClick={this.openKPForm}
                className='flex w-full xl:w-auto justify-center items-center gap-[9px] h-[38px] xl:h-[50px] px-[25px] bg-[#009EE3] text-white rounded-full cursor-pointer text-[14px] xl:text-[16px] hover:bg-[#0082c0] transition-colors duration-300'
              >
                <div>Получить коммерческое предложение</div>
                <ChevronIcon2 stroke="white" />
              </div>
              <div className='flex items-center justify-between gap-[10px] w-full xl:w-auto'>
                {/* Кнопка Уточнить цену */}
                <div 
                  onClick={this.openPriceForm}
                  className='flex flex-1 xl:flex-auto items-center justify-center gap-[9px] h-[38px] xl:h-[50px] px-[25px] bg-[#032432] text-white rounded-full cursor-pointer text-[14px] xl:text-[16px] hover:bg-opacity-90 transition-colors duration-300'
                >
                  <div>Уточнить цену</div>
                  <ChevronIcon2 stroke="white" />
                </div>
                <div className='hidden xl:flex items-center gap-[6px]'>
                  {market.map((item, index) => (
                    <a 
                      key={index} 
                      href={item.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className='hover:opacity-80 transition-opacity'
                    >
                      <img 
                        src={item.image} 
                        alt={item.name} 
                        width={50} 
                        height={50} 
                        className='w-[50px] h-[50px] object-contain'
                      />
                    </a>
                  ))}
                </div>
                <div className='flex xl:hidden items-center gap-[6px]'>
                  {market.map((item, index) => (
                    <a 
                      key={index} 
                      href={item.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className='hover:opacity-80 transition-opacity'
                    >
                      <img 
                        src={item.image} 
                        alt={item.name} 
                        width={38} 
                        height={38} 
                        className='w-[38px] h-[38px] object-contain'
                      />
                    </a>
                  ))}
                </div>
              </div>            
              {product?.hranenie != `` &&
                <>
                  <div className='w-[1px] h-[46px] bg-[#032432]/10 hidden xl:block' />
                  <div className='flex items-start gap-[9px] flex-1'>
                    <svg className='flex-none' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M22.9998 15.37V17.5601C22.9998 20.0001 21.2198 22.3 18.7998 22.97C18.6298 23.01 18.4499 23.01 18.2899 22.97C17.1099 22.65 16.0698 21.93 15.3398 21C14.5498 20.02 14.0898 18.8101 14.0898 17.5601V15.37C14.0898 14.95 14.3998 14.49 14.7798 14.33L17.5598 13.1899C18.1898 12.9399 18.8898 12.9399 19.5198 13.1899L20.5198 13.6L22.3098 14.33C22.6898 14.49 22.9998 14.95 22.9998 15.37Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M20.9493 11.0103L20.5193 13.6003L19.5193 13.1902C18.8893 12.9402 18.1893 12.9402 17.5593 13.1902L14.7793 14.3302C14.3993 14.4902 14.0893 14.9503 14.0893 15.3703V17.5604C14.0893 18.8104 14.5493 20.0203 15.3393 21.0003H6.1793C4.8093 21.0003 3.51931 19.9104 3.28931 18.5604L2.0293 11.0103C1.8693 10.0803 2.33929 8.83028 3.07929 8.24028L9.65931 2.98027C10.6693 2.17027 12.3093 2.17028 13.3193 2.99028L19.8993 8.24028C20.6293 8.83028 21.1093 10.0803 20.9493 11.0103Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <div>
                      <h3 className='text-[16px] xl:text-[18px] text-[#032432]'>Хранение</h3>
                      <div className='mt-[5px] text-[14px] xl:text-[16px] text-[#032432]/60'>{Parser(product?.hranenie)}</div>
                    </div>
                  </div>
                 </>
              }
            </div>
            {product?.content != `` &&
              <div className='table-container mt-[11px] text-[14px] xl:text-[16px] text-center xl:text-start text-[#032432]/60 overflow-x-auto overflow-y-hidden'>
                {Parser(product?.content)}
              </div>
            }
            {(product?.blocks || []).map((elm, index) => (
              <div key={index}>
                {elm?.name &&
                  <h2 className='font-medium mt-[40px] text-[24px] xl:text-[36px] text-center xl:text-start text-[#032432]'>{Parser(elm?.name)}</h2>
                }
                <div className='table-container mt-[11px] text-[14px] xl:text-[16px] text-center xl:text-start text-[#032432]/60 overflow-x-auto overflow-y-hidden'>
                  {Parser(elm?.text)}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Lightbox для увеличения изображения с лупой */}
        {lightboxOpen && (
          <div
            className='fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-95'
            onClick={this.closeLightbox}
          >
            {/* Кнопка закрытия */}
            <button
              className='absolute top-5 right-5 text-white text-4xl hover:text-gray-300 z-20 w-12 h-12 flex items-center justify-center rounded-full bg-black bg-opacity-60 hover:bg-opacity-80 transition-all'
              onClick={this.closeLightbox}
            >
              ×
            </button>

            {/* Контейнер с изображением и лупой */}
            <div
              className='relative w-[95vw] h-[95vh] flex items-center justify-center'
              onClick={(e) => e.stopPropagation()}
              onMouseUp={() => {
                if (this.isDragging) {
                  this.isDragging = false;
                }
              }}
              onMouseLeave={() => {
                if (this.isDragging) {
                  this.isDragging = false;
                }
              }}
            >
              <div
                ref={(el) => { this.zoomContainer = el; }}
                className='relative overflow-hidden rounded-[15px] bg-black select-none'
                style={{
                  width: '100%',
                  height: '100%',
                  maxWidth: '95vw',
                  maxHeight: '95vh',
                }}
                onMouseDown={(e) => {
                  if (this.state.zoomLevel <= 1) return;
                  this.isDragging = true;
                  this.dragStartX = e.clientX - this.dragOffsetX;
                  this.dragStartY = e.clientY - this.dragOffsetY;
                  const img = this.zoomContainer?.querySelector('img');
                  if (img) {
                    img.style.cursor = 'grabbing';
                    img.style.transition = 'none';
                  }
                }}
                onMouseMove={(e) => {
                  if (!this.isDragging || this.state.zoomLevel <= 1) return;
                  this.dragOffsetX = e.clientX - this.dragStartX;
                  this.dragOffsetY = e.clientY - this.dragStartY;
                  const img = this.zoomContainer?.querySelector('img');
                  if (img) {
                    img.style.transform = `scale(${this.state.zoomLevel}) translate(${this.dragOffsetX / this.state.zoomLevel}px, ${this.dragOffsetY / this.state.zoomLevel}px)`;
                  }
                }}
                onMouseUp={() => {
                  if (!this.isDragging) return;
                  this.isDragging = false;
                  const img = this.zoomContainer?.querySelector('img');
                  if (img) {
                    img.style.cursor = 'grab';
                    img.style.transition = '';
                  }
                }}
                onMouseLeave={() => {
                  if (!this.isDragging) return;
                  this.isDragging = false;
                  const img = this.zoomContainer?.querySelector('img');
                  if (img) {
                    img.style.cursor = 'grab';
                    img.style.transition = '';
                  }
                }}
              >
                <img
                  src={currentImage}
                  alt={data?.pagetitle || 'Увеличенное изображение'}
                  className={`w-full h-full object-contain transition-transform duration-200 ease-out ${
                    this.state.zoomLevel > 1 ? 'cursor-grab' : 'cursor-default'
                  }`}
                  draggable={false}
                  style={{
                    transform: `scale(${this.state.zoomLevel})`,
                    transformOrigin: 'center center',
                  }}
                />
              </div>
            </div>

            {/* Панель управления зумом снизу */}
            <div
              className='absolute bottom-8 left-1/2 -translate-x-1/2 z-20 flex items-center gap-4 bg-black bg-opacity-70 backdrop-blur-sm rounded-full px-5 py-3'
              onClick={(e) => e.stopPropagation()}
            >
              {/* Кнопка - */}
              <button
                onClick={() => {
                  this.dragOffsetX = 0;
                  this.dragOffsetY = 0;
                  this.setState((prev) => ({
                    zoomLevel: Math.max(1, +(prev.zoomLevel - 0.5).toFixed(1))
                  }));
                }}
                disabled={this.state.zoomLevel <= 1}
                className='w-10 h-10 flex items-center justify-center rounded-full bg-white bg-opacity-20 text-white text-2xl font-bold hover:bg-opacity-40 transition-all disabled:opacity-30 disabled:cursor-not-allowed'
                title='Уменьшить'
              >
                −
              </button>

              {/* Индикатор текущего зума */}
              <div className='text-white text-base font-medium min-w-[60px] text-center select-none'>
                {this.state.zoomLevel}x
              </div>

              {/* Кнопка + */}
              <button
                onClick={() => {
                  this.setState((prev) => ({
                    zoomLevel: Math.min(5, +(prev.zoomLevel + 0.5).toFixed(1))
                  }));
                }}
                disabled={this.state.zoomLevel >= 5}
                className='w-10 h-10 flex items-center justify-center rounded-full bg-white bg-opacity-20 text-white text-2xl font-bold hover:bg-opacity-40 transition-all disabled:opacity-30 disabled:cursor-not-allowed'
                title='Увеличить'
              >
                +
              </button>
            </div>
          </div>
        )}

        {/* Форма для коммерческого предложения */}
        <OffcanvasForm
          show={showKPForm}
          hide={this.closeKPForm}
          formTitle="Получить коммерческое предложение"
          productName={formProductName || ''}
          onSuccess={this.handleFormSuccess}
          onError={this.handleFormError}
        />

        {/* Форма для уточнения цены */}
        <OffcanvasForm
          show={showPriceForm}
          hide={this.closePriceForm}
          formTitle="Уточнить цену"
          productName={formProductName || ''}
          onSuccess={this.handleFormSuccess}
          onError={this.handleFormError}
        />
      </>
    );
  }
}

export default App;